import { DateTime } from "luxon";
import { z } from "zod/v4-mini";

import { toDateTime } from "@/utils/dateUtils.ts";

export const zodDateBefore = (date: DateTime, params?: string | z.core.$ZodCustomParams) => {
  return z.refine<string | DateTime>(value => toDateTime(value) < date, params);
};

export const zodDateAfter = (date: DateTime, params?: string | z.core.$ZodCustomParams) => {
  return z.refine<string | DateTime>(value => toDateTime(value) > date, params);
};

export const zodValidation = {
  dateBefore: zodDateBefore,
  dateAfter: zodDateAfter,
};
